import { useSelector } from 'react-redux';
import { getBaccaratMyBet } from '../selectors';

export const useGameMyBet = () => useSelector(getBaccaratMyBet);
